export default __webpack_public_path__ + "static/media/rabbit31.fd01168b.gif";